<style lang="scss" scoped>
@import "@/styles/variables.scss";
.box {
    color: $body-color;
    background: #fff;
    border-radius: $border-radius;
    border: 1px solid #e3eaee;
    position: relative;
    transition: 0.2s border;
    &.clickable {
        cursor: pointer;
        &:hover {
            border: 1px solid $body-color;
        }
    }
    .box-header {
    }
    .box-content {
    }
    .box-footer {
    }
}
</style>

<template>
    <div class="box" :class="{ clickable : clickable }" :style="{ padding: padding + 'px', 'border-radius': borderRadius  + 'px'}" @click="$emit('click')">

        <template v-if="!loading">
            <!-- Box header -->
            <div v-if="hasHeaderSlot" class="box-header d-flex">
                <slot name="header"></slot>
            </div>

            <!-- Box content -->
            <div v-if="hasContentSlot" class="box-content d-flex flex-column">
                <slot name="content"></slot>
            </div>

            <!-- Box footer -->
            <div v-if="hasFooterSlot" class="box-footer d-flex">
                <slot name="footer"></slot>
            </div>
        </template>

        <template v-else>
            <div class="text-center">
                <loader></loader>
            </div>
        </template>

    </div>
</template>

<script>
export default {
    props: {
        /**
         * Number defining the padding of the box
         * @type {Number}
         */
        padding: {
            type: Number,
            default: 30
        },

        /**
         * Number defining the border radius of the box
         * @type {Number}
         */
        borderRadius: {
            type: Number,
            default: 4
        },

        /**
         * Boolean defining if the card is clickable
         * @type {Boolean}
         */
        clickable: {
            type: Boolean,
            default: false
        },

        /**
         * Boolean defining if the card is loading
         * @type {Boolean}
         */
        loading: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        hasHeaderSlot() {
            return !!this.$slots["header"];
        },
        hasContentSlot() {
            return !!this.$slots["content"];
        },
        hasFooterSlot() {
            return !!this.$slots["footer"];
        }
    }
};
</script>
